module.exports = __webpack_public_path__ + "img/fi_copy.26df68e0.svg";